import { render, staticRenderFns } from "./MyFeedBack.vue?vue&type=template&id=a113fc6c&scoped=true"
import script from "./MyFeedBack.vue?vue&type=script&lang=js"
export * from "./MyFeedBack.vue?vue&type=script&lang=js"
import style0 from "./MyFeedBack.vue?vue&type=style&index=0&id=a113fc6c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a113fc6c",
  null
  
)

export default component.exports